import { render, staticRenderFns } from "./Projekte.vue?vue&type=template&id=a7e4df9e&scoped=true&"
import script from "./Projekte.vue?vue&type=script&lang=js&"
export * from "./Projekte.vue?vue&type=script&lang=js&"
import style0 from "./Projekte.vue?vue&type=style&index=0&id=a7e4df9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e4df9e",
  null
  
)

export default component.exports